<template>
    <v-view :tableData="tableData"
            :tableProps="tableProps"
            :modalProps="modalProps"
            :columns="columns"
            :routes="routes"
            :initialSort="initialSort"
            :buttonsVisibility="buttonsVisibility"
            :rowButtonAction="rowButtonAction"
            v-model:selectedRows="selectedRows">

        <template #crud="formProps">
            <AssessmentForm :formProps="formProps">
            </AssessmentForm>
        </template>
        <template #search="searchProps">
            <AssessmentSearch :searchProps="searchProps">
            </AssessmentSearch>
        </template>

    </v-view>
</template>

<script setup>
import AssessmentForm from './AssessmentForm.vue'
import AssessmentSearch from './AssessmentSearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
